import LKEAuth, { IDPIDTokenClaims } from '@beeline/lk-auth';

const authParamName = '___$$LKE_AUTH_INSTANCE$$___';
const externalWidgetAuthParamName = '___$$SCP_WIDGET_AUTH_INSTANCE___';

export interface ExternalWidgetAuth {
  requestAccessToken: () => Promise<string>;
  refreshAccessToken: () => Promise<string>;
  requestClaims: () => Promise<IDPIDTokenClaims>;
  getOriginalToken: () => Promise<{
    accessTokenType: string;
    accessToken: string;
  }>;
}

interface customWindow extends Window {
  [authParamName]: LKEAuth | undefined;
  [externalWidgetAuthParamName]: ExternalWidgetAuth | undefined;
}

declare const window: customWindow;

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const _window = window || global;

export function initAuth(authInstance: LKEAuth): void {
  if (_window[authParamName] === undefined) {
    _window[authParamName] = authInstance;
  }
}

export function getAuth(): LKEAuth | undefined {
  return _window[authParamName];
}

export function initExternalAuth(auth: ExternalWidgetAuth): void {
  _window[externalWidgetAuthParamName] = auth;
}

export function getExternalAuth(): ExternalWidgetAuth | undefined {
  return _window[externalWidgetAuthParamName];
}
